import { Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import styled from 'styled-components';

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  background: ${theme.GREY_10};
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${theme.GREY_20};
  }
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${theme.GREY_20};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 16px;
  overflow: hidden;
`;

const ItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: ${(props) => (props.active ? theme.SUCCESS + '20' : theme.GREY_30)};
  color: ${(props) => (props.active ? theme.SUCCESS : theme.GREY_60)};
`;

const TierBadge = styled.span`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-right: 4px;
  background: ${(props) => {
    if (props.tier === 'gold') return '#FFD70030';
    if (props.tier === 'silver') return '#C0C0C030';
    return '#CD7F3230';
  }};
  color: ${(props) => {
    if (props.tier === 'gold') return '#B8860B';
    if (props.tier === 'silver') return '#808080';
    return '#8B4513';
  }};
`;

const RewardTypeItem = ({ item, onClick, onDelete }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick(item);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(item);
  };

  const eligibleTiers = [];
  if (item.eligibility?.bronze?.eligible) eligibleTiers.push('bronze');
  if (item.eligibility?.silver?.eligible) eligibleTiers.push('silver');
  if (item.eligibility?.gold?.eligible) eligibleTiers.push('gold');

  return (
    <ItemContainer onClick={handleClick}>
      <IconWrapper>
        {item.image ? <ItemImage src={item.image} alt={item.name} /> : '🎁'}
      </IconWrapper>

      <Col wid="100%">
        <Row between center>
          <Text med>{item.name}</Text>
          <Row noFlex center gap="8px">
            <StatusBadge active={item.isActive}>{item.isActive ? 'Active' : 'Inactive'}</StatusBadge>
            <Clickable onClick={handleDelete}>
              <FiTrash2 size={16} color={theme.GREY_60} />
            </Clickable>
          </Row>
        </Row>

        <Row start marg="8px 0 0" center>
          <Text c1 col={theme.GREY_60} style={{ marginRight: 12 }}>
            {item.type === 'raffle' ? 'Raffle' : 'Direct'}
          </Text>

          {eligibleTiers.map((tier) => (
            <TierBadge key={tier} tier={tier}>
              {tier.charAt(0).toUpperCase() + tier.slice(1)}
            </TierBadge>
          ))}
        </Row>

        {item.description && (
          <Text c1 col={theme.GREY_50} marg="8px 0 0" style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '500px'
          }}>
            {item.description}
          </Text>
        )}
      </Col>
    </ItemContainer>
  );
};

export default RewardTypeItem;
